import type { RouteStop } from '@models/route'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import routesApi from './actions'
import { routesKeys } from './constants'

interface UseStopsData {
  stops: RouteStop[]
  stopsMap: Map<number, RouteStop>
}

export const selectData = (data: RouteStop[]): UseStopsData => {
  return {
    stops: data,
    stopsMap: new Map(data.map(stop => [stop.id, stop])),
  }
}

const useRouteStops = (routeId?: number) => {
  const query = useQuery<RouteStop[], AxiosError, UseStopsData>(
    routesKeys.stops(routeId!),
    () => routesApi.getStops(routeId!),
    { select: selectData, enabled: !!routeId },
  )

  return query
}

export default useRouteStops
